module.exports = __webpack_public_path__ + "epdf-app/dashboard/message/message-details-2h-a587v.html";